import React, { useRef } from "react";
import { WSPill, WSPillProps } from "../common/WSPill/WSPill.component";
import { WSButton, WSButtonProps, WSIcon, WSIconProps } from "../core";
import { WSText } from "../core/WSText/WSText.component";
import { WSElement } from "../WSElement/WSElement.component";
import { WSMenu, WSMenuProps, WSMenuRef } from "../WSMenu/WSMenu.component";
import {
  WSTooltipIcon,
  WSTooltipIconProps
} from "../WSTooltipIcon/WSTooltipIcon";
import styles from "./WSCardHeaderValue.module.scss";

export type WSCardHeaderValueProps = {
  value?: string;
  action?: WSButtonProps<"Link">;
  pill?: WSPillProps;
  stacked?: boolean;
  menu?: WSMenuProps["items"];
  tooltip?: WSTooltipIconProps["tooltip"];
  icon?: WSIconProps;
};

export const WSCardHeaderValue: React.FC<WSCardHeaderValueProps> = (props) => {
  const valueElement = props.value ? (
    <WSText kind="Paragraph" weight="medium" color="gray700">
      {props.value}
    </WSText>
  ) : undefined;

  const actionElement = props.action ? (
    <WSButton.Link alignment="right" {...props.action} />
  ) : undefined;

  const pillElement = props.pill ? <WSPill {...props.pill} /> : undefined;

  const iconElement = props.icon ? <WSIcon {...props.icon} /> : undefined;

  const menuElement =
    props.menu && props.menu.length > 0 ? (
      <MenuIcon items={props.menu} />
    ) : undefined;

  const tooltipElement = props.tooltip ? (
    <WSTooltipIcon tooltip={props.tooltip} />
  ) : undefined;

  return (
    <WSElement className={styles.value}>
      {tooltipElement}
      {valueElement}
      {pillElement}
      {iconElement}
      {actionElement}
      {menuElement}
    </WSElement>
  );
};

const MenuIcon: React.FC<WSMenuProps> = (props) => {
  const menuRef = useRef<WSMenuRef>(null);

  return (
    <>
      <WSMenu ref={menuRef} {...props} />
      <WSIcon
        color="gray500"
        size="M"
        name="dots-v"
        onClick={(event) => {
          menuRef.current?.toggle(event);
        }}
      />
    </>
  );
};
